import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAirpodLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"airpod-left"} maskId="square-filled-radius-0-stroke-1-IconAirpodLeft"><path d="M9 3C10.6357 3 12.0878 3.78565 13 5V10.999C12.0878 12.2137 10.636 13 9 13C8.6575 13 8.32314 12.965 8 12.8994V21H4V8C4 5.23858 6.23858 3 9 3Z" fill="currentColor"/><path d="M16 20H20V21H15V13H16V20Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconAirpodLeft;
